const $ = require('jquery')

class LoadMore {
    defaultPage = 2
    loading = false
    isClick = false

    constructor() {
        if (typeof search === "undefined"){
            this.loadMoreArticlesByScroll()
            this.loadMoreArticlesByClick()
        }else {
            this.loadMoreArticlesByClick()
        }
    }

    loadMoreArticlesByScroll() {
        let _this = this
        $(window).scroll(function () {
            if(_this.defaultPage >= 1 ) {
                $('.view-more').removeClass('hidden')
                    return
            }
            
            let URL = $('.view-more').attr('href')
            let isLoadmore = $(window).scrollTop() > $(document).height() - $(window).height() - 1000
            if ( isLoadmore && typeof URL !== undefined && _this.loading !== true && loadMore === true ) {
                _this.loading = true
                $.ajax({
                    beforeSend() {
                        $('.view-more').removeClass('hidden')
                    },
                    url: URL,
                    method: 'GET',
                    data: {
                        page: _this.defaultPage
                    }
                }).done(function (results) {
                    $('.view-more').parent().remove()
                    _this.defaultPage += 1
                    _this.loading = false
                    $(`${elementNeedAppend}`).append(results)
                    $('.view-more').addClass('hidden')
                })
            }
        })


    }

    loadMoreArticlesByClick() {
        let _this = this
        $('body').on('click', '.view-more', function (e) {
            e.preventDefault()
            let URL = $('.view-more').attr('href')
            if(typeof URL !== undefined && _this.loading !== true ) {
                $.ajax({
                    beforeSend() {
                        _this.loading = true
                    },
                    url: URL,
                    method: 'GET',
                    data: {
                        page: _this.defaultPage
                    }
                }).done(function (results){
                    $('.view-more').parent().remove()
                    _this.defaultPage += 1
                    _this.loading = false
                    $(`${elementNeedAppend}`).append(results)
                })
            }
        })
    }

}

export default $(document).ready(function () {
    new LoadMore
})
